import React from 'react';

const LinkOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
    >
        <path
            d="m11.233 5.417 1.137-1.15a2.5 2.5 0 1 1 3.535 3.536L12.37 11.34a2.5 2.5 0 0 1-3.536 0m.732 2.828-1.363 1.339a2.5 2.5 0 0 1-3.536-3.536l3.536-3.535a2.5 2.5 0 0 1 3.536 0"
            stroke="#009FDF"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);
export default LinkOutlined;
